<script lang="ts" setup>
import Card from '~/components/workshop/card.vue'
import type {WorkshopSwipeCard} from '~/types/workshop'

const props = defineProps<{
  data: Exclude<WorkshopSwipeCard, undefined | null>
}>()
</script>

<template>
  <Container class="screen-content flex flex-col space-y-6 pt-32 md:pb-16 lg:pb-16 lg:pt-48">
    <div class="text-left">
      <span class="text-sm font-bold text-main-600">{{ data.eyebrow }}</span>
      <Heading as="h3" size="large">{{ data.title }}</Heading>
      <Paragraph class="text-gray-600">{{ data.description }}</Paragraph>
    </div>
  </Container>

  <Container class="space-y-16 pb-24">
    <Card :items="data.carouselCards ?? []" />
  </Container>
</template>
